import React from 'react';
import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: 'Product',
    links: [
      { label: 'All Features', path: '/features' },
      { label: 'AI Assessment', path: '/features/ai-assessment' },
      { label: 'Remote Desktop', path: '/features/remote-desktop' },
      { label: 'Neural Driver', path: '/features/neural-driver' },
      { label: 'Screen Capture', path: '/features/screen-capture' },
      { label: 'Download', path: '/download' },
      { label: 'Pricing', path: '/pricing' },
    ]
  },
  {
    title: 'Alternatives',
    links: [
      { label: 'vs CodeTantra', path: '/alternatives/codetantra' },
      { label: 'vs Mercer Mettl', path: '/alternatives/mercer-mettl' },
      { label: 'vs LPU NEST', path: '/alternatives/lpu-nest' },
      { label: 'vs Neo Browser', path: '/alternatives/neo-browser' },
      { label: 'vs Duolingo', path: '/alternatives/duolingo' },
      { label: 'vs Safe Exam Browser', path: '/alternatives/safe-exam-browser' },
      { label: 'vs LockDown Browser', path: '/alternatives/lockdown-browser' },
    ]
  },
  {
    title: 'Resources',
    links: [
      { label: 'Blog', path: '/blog/best-ai-study-tools-2026' },
      { label: 'AI in Education', path: '/blog/how-ai-changing-education' },
      { label: 'Remote Desktop Guide', path: '/blog/remote-desktop-guide' },
      { label: 'FAQ', path: '/faq' },
      { label: 'For Students', path: '/use-cases/students' },
      { label: 'For Developers', path: '/use-cases/developers' },
    ]
  },
  {
    title: 'Company',
    links: [
      { label: 'About', path: '/about' },
      { label: 'Contact', path: '/contact' },
      { label: 'Partners', path: '/partners' },
      { label: 'Terms', path: '/terms', external: true },
    ]
  }
];

export default function SEOFooter() {
  return (
    <>
      <style>{`
        .sfooter {
          background: #08080f;
          border-top: 1px solid rgba(99, 102, 241, 0.08);
          padding: 80px 24px 32px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }
        .sfooter-inner {
          max-width: 1200px;
          margin: 0 auto;
        }
        .sfooter-top {
          display: grid;
          grid-template-columns: 1.5fr repeat(4, 1fr);
          gap: 40px;
          margin-bottom: 64px;
        }
        .sfooter-brand {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .sfooter-brand-name {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 1.15rem;
          font-weight: 800;
          color: #e4e6f0;
          letter-spacing: -0.02em;
          text-decoration: none;
        }
        .sfooter-brand-icon {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          background: linear-gradient(135deg, #6366f1, #06b6d4);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.9rem;
          font-weight: 900;
          color: white;
        }
        .sfooter-brand-desc {
          font-size: 0.9rem;
          color: #636888;
          line-height: 1.7;
          max-width: 280px;
        }
        .sfooter-col-title {
          font-size: 0.8rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          color: #818cf8;
          margin-bottom: 20px;
        }
        .sfooter-links {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .sfooter-links a {
          color: #9ba0c2;
          text-decoration: none;
          font-size: 0.88rem;
          transition: all 0.25s ease;
          display: inline-block;
        }
        .sfooter-links a:hover {
          color: #e4e6f0;
          transform: translateX(3px);
        }
        .sfooter-divider {
          height: 1px;
          background: rgba(99, 102, 241, 0.06);
          margin-bottom: 24px;
        }
        .sfooter-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        }
        .sfooter-copyright {
          font-size: 0.82rem;
          color: #636888;
        }
        .sfooter-disclaimer {
          font-size: 0.78rem;
          color: #4a4e6a;
          max-width: 500px;
          line-height: 1.6;
          text-align: right;
        }
        @media (max-width: 900px) {
          .sfooter-top {
            grid-template-columns: 1fr 1fr;
            gap: 32px;
          }
          .sfooter-brand {
            grid-column: span 2;
          }
        }
        @media (max-width: 560px) {
          .sfooter-top {
            grid-template-columns: 1fr;
          }
          .sfooter-brand {
            grid-column: span 1;
          }
          .sfooter-bottom {
            flex-direction: column;
            text-align: center;
          }
          .sfooter-disclaimer {
            text-align: center;
          }
          .sfooter { padding: 48px 16px 24px; }
        }
      `}</style>

      <footer className="sfooter" role="contentinfo">
        <div className="sfooter-inner">
          <div className="sfooter-top">
            <div className="sfooter-brand">
              <Link to="/" className="sfooter-brand-name">
                <div className="sfooter-brand-icon">CS</div>
                CheckScript AI
              </Link>
              <p className="sfooter-brand-desc">
                AI-powered assessment assistant & developer productivity platform. 
                Trusted by thousands of students and developers worldwide.
              </p>
            </div>

            {footerColumns.map(col => (
              <div key={col.title}>
                <h3 className="sfooter-col-title">{col.title}</h3>
                <ul className="sfooter-links">
                  {col.links.map(link => (
                    <li key={link.path}>
                      {link.external ? (
                        <a href={link.path}>{link.label}</a>
                      ) : (
                        <Link to={link.path}>{link.label}</Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="sfooter-divider" />

          <div className="sfooter-bottom">
            <p className="sfooter-copyright">
              © {new Date().getFullYear()} CheckScript AI. All rights reserved.
            </p>
            <p className="sfooter-disclaimer">
              CheckScript is designed for educational purposes. Users are responsible 
              for complying with their institution's policies.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
